@if (patient) {
  <app-traitement-data-mode [patient]="patient!" />
  <app-traitement-data-epap-ipap [patient]="patient!" />
  <app-traitement-data-frequence [patient]="patient!" />
  <app-traitement-data-iahr [patient]="patient!" />
  <app-traitement-data-obs [patient]="patient!" />
  <app-traitement-data-volume-courant-mediane-95 [patient]="patient!" />
  <app-traitement-data-frequence-respiratoire-mediane-95 [patient]="patient!" />
  <app-traitement-data-fuites-mediane-95 [patient]="patient!" />
  @if (activite == "O2VNI") {
    <app-traitement-data-o2-repos [patient]="patient!" />
    <app-traitement-data-o2-effort [patient]="patient!" />
    <app-traitement-data-duree [patient]="patient!" />
  }
} @else {
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
}
